import React from 'react'
import { Container, Header, Box } from '@cloudscape-design/components'

interface KpiCardProps {
  title: string
  value: string | number
  icon?: React.ReactNode
  loading?: boolean
  href?: string
}

export default function KpiCard({ title, value, icon, loading, href }: KpiCardProps) {
  const content = (
    <Container>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <Box variant="awsui-key-label" fontSize="body-s" color="text-label">
            {title}
          </Box>
          <Box 
            fontSize="display-l" 
            fontWeight="bold" 
            color="text-body-default"
            textAlign="left"
          >
            {loading ? '-' : value}
          </Box>
        </Box>
        {icon && (
          <Box color="text-status-info">
            {icon}
          </Box>
        )}
      </Box>
    </Container>
  )

  if (href) {
    return (
      <Box as="a" href={href} textDecoration="none" color="inherit">
        {content}
      </Box>
    )
  }

  return content
}